import React, { Fragment, useCallback, useRef } from 'react';
import { openInsideChatTab } from '../../../page/components/inside-chat';
import { Helpers } from '../../../core/src/helpers';
import { withError } from '../../../shared/components/error-boundary';
import AboveTheFoldOnlyServerRender from '../../../shared/components/above-the-fold-only-server-render';
import useTrackCustomMetric from '../../../hooks/useTrackCustomMetric';
import useUserData from '../../../hooks/useUserData';
import { useThirdPartyTags } from '../../../hooks/useSiteConfig';

import './chatbot.less';

const DEFAULT_CHAT_HTML = `
<div id="webchat" role="main"></div>
       <span class="chatButtonGroup">
		  <span class="action_btn">
			<span class="buttonBorderStyle"><a href="/us-en/shop/cv/hp-store-contacts?jumpid=in_rose-chatbot" target="_blank" class="button2">LIVE AGENT</a></span>
			<span id="chatMenu" class="buttonBorderStyle"><a href="#MainMenu" class="button2">MAIN MENU</a></span>
			<span id="chatEnd" class="buttonBorderStyle"><a href="#EndChat" class="button2">END CHAT</a></span>
		  </span>
       </span>`;

var _isSmallMob = function () {
    var isMobileDevice = window.matchMedia('only screen and (max-width: 375px)');
    return isMobileDevice.matches;
};

var _isMediumMob = function () {
    var isMobileDevice = window.matchMedia('only screen and (max-width: 760px)');
    return isMobileDevice.matches;
};

export const Chatbot = ({ chatMenuHtml = DEFAULT_CHAT_HTML }) => {
    const { enableInsideChat, enableRose } = useThirdPartyTags(['enableInsideChat', 'enableRose']);
    const { userData } = useUserData();
    const { profileData, updatedFromService } = userData || {};
    const { isccf } = profileData || {};
    const onChatClick = useCallback(() => {
        try {
            if (enableInsideChat) {
                return openInsideChatTab();
            }
            window.maximize();
            trackCustomMetric('chat', {
                event: 'e_chat',
                chatAction: `rose_start`,
            });
        } catch (e) {}
    }, [enableInsideChat]);

    const trackCustomMetric = useTrackCustomMetric();

    const chatBotRef = useRef();

    const trackRoseEnterPress = useCallback(
        e => {
            try {
                if (
                    [e.which, e.keyCode].includes(13) &&
                    document.activeElement.getAttribute('data-id') === 'webchat-sendbox-input'
                ) {
                    trackCustomMetric('chat', {
                        event: 'e_chat',
                        chatAction: `rose_typed_message`,
                    });
                }
            } catch (e) {}
        },
        [trackCustomMetric],
    );

    //wait till user data is available and make sure it's not call center
    if (!updatedFromService || isccf) {
        return null;
    }

    if (typeof window === 'undefined') {
        return null;
    }

    let chatbotDivProps = {};
    let chatbotCommonProps = {};

    if (enableRose && !enableInsideChat) {
        chatbotDivProps = {
            onKeyDown: trackRoseEnterPress,
            dangerouslySetInnerHTML: Helpers.createMarkup(chatMenuHtml),
        };
        chatbotCommonProps = { style: { display: 'none' } };
    }
    return (
        <Fragment>
            {/*dangerously insert webchat html so it never re-renders*/}
            <div className="chatbox" id="chatbox" style={{ display: 'none' }} ref={chatBotRef} {...chatbotDivProps} />
            <div id="chatboxMin" {...chatbotCommonProps}>
                <div className="chatbox-avatar-min">
                    <a
                        href="#ChatWithRose"
                        onClick={onChatClick}
                        title="Ask Rose. I'm your HP Store Virtual Assistant(U.S. store only)."
                    >
                        <img
                            src="https://www.hp.com/wcsstore/HPStorefrontAssetStore/images/Rose_80X80.jpg"
                            style={{ borderRadius: '50%' }}
                            alt="Chat"
                        />
                    </a>
                </div>
            </div>
        </Fragment>
    );
};

export default withError(
    ({ lazyLoadSettings = { robots: false, skip: true, mobileOffset: 500, offset: 1000 }, ...restProps }) => {
        const { enableRose } = useThirdPartyTags(['enableRose', 'enableInsideChat']);
        if (!enableRose) {
            return null;
        }
        return (
            <AboveTheFoldOnlyServerRender {...lazyLoadSettings}>
                <Chatbot {...restProps} />
            </AboveTheFoldOnlyServerRender>
        );
    },
);
